import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import bb22 from "../Images/bb22.jpg";
import marketing from "../Images/marketing.jpg";
import sales from "../Images/sales.jpg";
import inventory from "../Images/inventory.jpg";
import analytics from "../Images/analytics.jpg";
import account from "../Images/account.jpg";
import happyclient from "../Images/happyclient.gif";
import digital1 from "../Images/digital1.gif";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";
import "./Home.css";

export default function Home() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsLoggedIn(!!token);
  }, []);

  // Download function for EyeSense AI
  const downloadEyeSenseAI = () => {
    const softwareInfo = {
      softwareName: "EyeSense AI Surveillance System",
      version: "3.0.0",
      releaseDate: new Date().toISOString(),
      features: [
        "Real-Time Threat Detection with 99.9% accuracy",
        "AI Behavior Analysis & Pattern Recognition",
        "Instant Multi-Channel Alerts & Notifications",
        "Automatic License Plate Recognition (ALPR)",
        "Advanced Face Recognition System",
        "Automated Daily/Weekly/Monthly Reports",
        "24/7 Automated Monitoring",
        "Support for 50+ Cameras Simultaneously",
        "Cloud Backup & Secure Storage",
        "Mobile App Integration for Remote Monitoring",
      ],
      specifications: {
        uptime: "99.9%",
        detectionAccuracy: "95%",
        responseTime: "< 2 seconds",
        cameraSupport: "50+ cameras",
        storage: "Cloud-based with local backup",
        aiModel: "Deep Learning Neural Networks",
      },
      systemRequirements: {
        os: "Windows 10/11, macOS 11+, Linux Ubuntu 20.04+",
        ram: "8GB minimum (16GB recommended)",
        storage: "20GB free space",
        processor: "Intel i5/AMD Ryzen 5 or higher",
        graphics: "NVIDIA GPU with 4GB VRAM recommended",
        internet: "Broadband connection for cloud features",
      },
      pricing: {
        basic: "Free Trial - 30 days",
        professional: "$199/month - Up to 20 cameras",
        enterprise: "Custom pricing - Unlimited cameras",
      },
      contactInfo: {
        email: "eyesense@entelipro.com",
        phone: "+1 (555) 234-5678",
        website: "https://entelipro.com/eyesense",
        support: "support@entelipro.com",
      },
    };

    const dataStr = JSON.stringify(softwareInfo, null, 2);
    const dataUri =
      "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);
    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", dataUri);
    linkElement.setAttribute(
      "download",
      `EyeSense_AI_Complete_Package_${new Date().toISOString().slice(0, 19)}.json`,
    );
    linkElement.click();
  };

  // Download brochure function
  const downloadBrochure = () => {
    const brochureContent = `EYESENSE AI - INTELLIGENT SURVEILLANCE SYSTEM
==========================================

Product Overview:
-----------------
EyeSense AI is an advanced artificial intelligence-powered surveillance solution that transforms traditional CCTV systems into proactive security tools. Unlike conventional cameras that simply record footage, EyeSense AI actively analyzes behaviors, detects threats, and alerts security personnel in real-time.

Key Capabilities:
-----------------
✓ Real-Time Threat Detection - Identifies suspicious movements, unauthorized access, and unusual behaviors instantly
✓ AI Behavior Analysis - Learns patterns and reduces false alarms through machine learning
✓ Automatic License Plate Recognition - Tracks vehicles entering and exiting your premises
✓ Face Recognition - Matches faces against databases for authorized personnel and blacklists
✓ Smart Alerts - Sends instant notifications via SMS, email, or mobile app
✓ Automated Reporting - Generates daily, weekly, and monthly security reports
✓ Multi-Camera Support - Integrates with existing CCTV infrastructure (50+ cameras)

Technical Specifications:
------------------------
• Detection Accuracy: 95% with continuous improvement
• Response Time: Under 2 seconds
• System Uptime: 99.9% guaranteed
• Camera Compatibility: ONVIF, RTSP, HTTP protocols
• Storage: Cloud-based with 30-day retention
• AI Model: Deep learning neural networks

Use Cases:
----------
🏢 Corporate Offices - Employee entry tracking, visitor management
🏭 Manufacturing Plants - Restricted area monitoring, safety compliance
🏫 Educational Institutions - Campus security, attendance tracking
🏥 Healthcare Facilities - Patient monitoring, access control
🛍️ Retail Stores - Theft prevention, customer behavior analysis
🏘️ Residential Communities - Gate entry, suspicious activity detection

Benefits:
---------
• 40% reduction in security costs
• 95% increase in threat detection accuracy
• 24/7 automated monitoring without fatigue
• Eliminate manual log keeping
• Faster emergency response times
• Comprehensive audit trails

Installation Requirements:
-------------------------
• Operating System: Windows 10/11, macOS 11+, or Linux Ubuntu 20.04+
• RAM: 8GB minimum (16GB recommended)
• Storage: 20GB free space
• Processor: Intel i5/AMD Ryzen 5 or higher
• Graphics: Dedicated GPU with 4GB VRAM recommended
• Internet: Broadband connection for cloud features

Pricing Plans:
-------------
🎁 Free Trial - 30 days full access
💼 Professional - $199/month (up to 20 cameras)
🏢 Enterprise - Custom pricing (unlimited cameras)

Contact Information:
-------------------
📧 Email: support@entelipro.com
📞 Phone: +91 7676289081
🌐 Website: https://entelipro.com/eyesense
🆘 Support: support@entelipro.com

Download Now: https://entelipro.com/download/eyesense-ai-setup.exe

© 2024 EnteliPro Solutions. All rights reserved.
`;

    const dataUri =
      "data:text/plain;charset=utf-8," + encodeURIComponent(brochureContent);
    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", dataUri);
    linkElement.setAttribute(
      "download",
      `EyeSense_AI_Brochure_${new Date().toISOString().slice(0, 10)}.txt`,
    );
    linkElement.click();
  };

  return (
    <>
      <SEO
        title="AI ERP Software & CRM Solutions for Businesses"
        description="EnteliPro offers AI-powered ERP software, intelligent CRM solutions, and automated business management to accelerate growth, sales, and productivity."
        keywords="AI ERP Software, CRM Solutions for Businesses, Intelligent Business Management, Cloud AI ERP, Predictive CRM Analytics, AI ERP solutions for small business"
        canonical="https://www.entelipro.com/"
        ogImage="https://www.entelipro.com/static/media/bb22.jpg"
      />

      <link rel="stylesheet" href="navigate/assets/css/style-starter.css" />
      <link
        href="https://fonts.googleapis.com/css?family=Nunito:400,600,700&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Muli:400,600,700&display=swap"
        rel="stylesheet"
      />

      <Navbar />

      <div className="w3l-hero-headers-9">
        <section className="slide slide-one">
          <div className="container">
            <div className="row">
              <div className="banner-text col-lg-5">
                <h1 style={{ fontSize: "2.5rem", fontWeight: "700", marginBottom: "1rem" , color: "#ffffff" }}>
                  AI Powered <br /> ERP for Business
                </h1>
                <p>
                  Intelligent AI Solution that learns from you.Increase your
                  Sales, Grow and Retain your customer.
                </p>
                {isLoggedIn ? (
                  <Link
                    to="/crm-dashboard"
                    className="btn logo-button top-margin"
                  >
                    Go to Dashboard
                  </Link>
                ) : (
                  <form action="login.jsp" name="register" method="post">
                    {" "}
                    <Link
                      to="register"
                      onclick="document.register.submit()"
                      className="btn logo-button top-margin"
                    >
                      Register
                    </Link>
                    <input type="hidden" name="type" defaultValue="register" />
                  </form>
                )}
                <h6 className="para">
                  Try a <strong> Free Demo </strong>with all the features.
                </h6>
              </div>
              <div className="image-postion col-lg-7">
                <img
                  src={bb22}
                  alt="EnteliPro AI ERP Business Solutions Platform"
                  className="img-responsive banner-images hero-dashboard-img"
                />
              </div>
            </div>
            {/* </div> */}
          </div>
        </section>
      </div>

      <section className="w3l-call-to-action_9">
        <div className="call-w3">
          <div className="container">
            <div className=" main-cont-wthree-2">
              <div className="left-contect-calls text-center">
                <div className="call-grids-w3 ">
                  <div className="grids-effect-2">
                    <img src={marketing} alt="EnteliPro AI Marketing Automation" />
                  </div>
                  <div className=" grids-effect-2">
                    <img src={sales} alt="EnteliPro AI CRM Sales Management" />
                  </div>
                  <div className="grids-effect-2">
                    <img src={inventory} alt="EnteliPro Cloud Inventory Management" />
                  </div>
                  <div className="grids-effect-2">
                    <img src={account} alt="EnteliPro Automated Accounting and Financial Management" />
                  </div>
                  <div className="grids-effect-2">
                    <img src={analytics} alt="EnteliPro Business Intelligence and ERP Analytics" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-teams-15">
        <div className="team-single-main">
          <div className="container">
            <div className=" grid grid-column-2 row">
              <div className="column1 col-lg-6">
                <img
                  src={happyclient}
                  alt="Satisfied Clients Using EnteliPro CRM Solutions"
                  className="img-responsive "
                />
              </div>
              <div className="column2 col-lg-6">
                <h3 className="team-head">
                  A better business means better client experience
                </h3>
                <p className="para text">
                  The journey involves understanding the customer requirements.{" "}
                  {`${project_name}`} offers you a well executed{" "}
                  <Link to="customer_services">customer service</Link>{" "}
                  strategy which will maximize customer lifetime value. Customer
                  experience impacted customers enthusiasm for being brand
                  advocates. We provide the smooth{" "}
                  <Link to="communication">communication</Link>{" "}
                  process between
                  your business and customers. Everything you do impacts your
                  customer's perception and their decision to keep coming back.
                </p>
                <p className="para mt-2 dis-none">
                  We provide you with every touch point a customer ever has with
                  your business. By having a measurable indicator of the
                  customer, you can track how your business improves over time
                  and use it to evaluate your success stories.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-specification-6">
        <div className="specification-layout">
          <div className="container">
            <div className="main-titles-head">
              <h3 className="header-name">
                We Bring The Best Things For Business
              </h3>
            </div>
            <div className="specification-effect row text-center">
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-thumbs-up" aria-hidden="true" />
                  <h4>
                    <Link to="/promotions" className="title-head">
                      Promotions
                    </Link>
                  </h4>
                  <p className="para">
                    {`${project_name}`} provides you with focused{" "}
                    <Link to="/promotions">promotional</Link> activities which is
                    an excellent way to introduce your product in the market.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-share-alt" aria-hidden="true" />
                  <h4>
                    <Link to="/crmmarketing" className="title-head">
                      Social Media
                    </Link>
                  </h4>
                  <p className="para">
                    With {`${project_name}`} get campaigns based on your
                    business goals will create a brand identity and positive
                    brand association.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-pie-chart" aria-hidden="true" />
                  <h4>
                    <Link to="/360degreeview" className="title-head">
                      360 Degree View
                    </Link>
                  </h4>
                  <p className="para">
                    {`${project_name}`}{" "}
                    <Link to="/360degreeview">360 degree</Link> customer view
                    strategic approach enabling businesses to offer the best
                    customer experience across all channels.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-mobile" aria-hidden="true" />
                  <h4>
                    <Link to="/digitalmobile" className="title-head">
                      Digital &amp; Mobile
                    </Link>
                  </h4>
                  <p className="para">
                    Utilize the amazing{" "}
                    <Link to="/digitalmobile">technology</Link> wherever you are
                    to benefit your business. View data and receive valuable
                    alerts in mobile.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-bolt" aria-hidden="true" />
                  <h4>
                    <Link to="/crmmarketing" className="title-head">
                      Marketing
                    </Link>
                  </h4>
                  <p className="para">
                    Works best for you that will determine and pursue your{" "}
                    <Link to="/crmmarketing">business marketing</Link> goals.
                    Boost visibility and increase sales while sustaining a
                    profit.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 uniform-card-wrapper">
                <div className="back-color uniform-service-card">
                  <span className="fa fa-cubes" aria-hidden="true" />
                  <h4>
                    <Link to="/planning" className="title-head">
                      Planing
                    </Link>
                  </h4>
                  <p className="para">
                    Get high level overview of your entire business that will
                    develop a better understanding of effective business{" "}
                    <Link to="/planning">planning</Link> process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* grids block 4 */}
      <section className="w3l-grids-7">
        <div className="grids4-block">
          <div className="container">
            <div className="row">
              <div className="column-text col-lg-6">
                <h3 className="team-head">Create Digital Presence</h3>
                <p className="para text">
                  {" "}
                  Digital Presence matters whenever any person searches for your
                  business online. We will make you go digitally.
                </p>
                <div className="digital-presence-grid">
                  <div className="digital-presence-card">
                    <h4>
                      <Link to="crm_analysis" className="title-head">
                        Data Analysis
                      </Link>
                    </h4>
                    <p className="para">
                      Deeper understanding which, in turn, builds better
                      business relationships.
                    </p>
                  </div>
                  <div className="digital-presence-card">
                    <h4>
                      <Link to="analytics" className="title-head">
                        ERP Analytics
                      </Link>
                    </h4>
                    <p className="para">
                      Enable decision-makers to make better and more timely
                      business decisions
                    </p>
                  </div>
                  <div className="digital-presence-card">
                    <h4>
                      <Link to="digitalmarketing" className="title-head">
                        Digital Marketing
                      </Link>
                    </h4>
                    <p className="para">
                      Allows you to find new{" "}
                      <Link to="digitalmarketing">markets</Link> and trade
                      globally for only a small investment.
                    </p>
                  </div>
                  <div className="digital-presence-card">
                    <h4>
                      <Link to="crmmarketing" className="title-head">
                        Social Marketing
                      </Link>
                    </h4>
                    <p className="para">
                      Increase your business's recognition, traffic, and sales
                      with little to no cost.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <img src={digital1} alt="EnteliPro Digital Presence and Business Management Solutions" className="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* EyeSense AI Promo Banner */}
      <section
        className="w3l-eyesense-promo"
        style={{
          backgroundColor: "#1a1a2e",
          color: "white",
          padding: "30px 0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h3 style={{ fontSize: "28px", marginBottom: "10px" }}>
                🔒 Introducing EyeSense AI - Smart Surveillance System
              </h3>
              <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                AI-powered security solution that detects suspicious activity,
                logs daily commute, and reports to admin automatically.
              </p>
              <p style={{ fontSize: "14px", opacity: 0.9 }}>
                ✓ Real-time threat detection ✓ Face recognition ✓ License plate
                tracking ✓ Automated reports
              </p>
            </div>
            <div
              className="col-lg-4 text-right"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={downloadEyeSenseAI}
                className="btn"
                style={{
                  backgroundColor: "#e74c3c",
                  color: "white",
                  padding: "12px 30px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                📥 Download Now
              </button>
              <button
                onClick={downloadBrochure}
                className="btn"
                style={{
                  backgroundColor: "#3498db",
                  color: "white",
                  padding: "12px 20px",
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                📄 Brochure
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* EyeSense AI Features Section */}
      <section
        className="w3l-eyesense-features"
        style={{ padding: "60px 0", backgroundColor: "#f8f9fa" }}
      >
        <div className="container">
          <div className="main-titles-head text-center">
            <h3
              className="header-name"
              style={{ fontSize: "32px", marginBottom: "15px" }}
            >
              EyeSense AI - Intelligent Surveillance Solution
            </h3>
            <p
              className="para"
              style={{
                fontSize: "18px",
                maxWidth: "800px",
                margin: "0 auto 40px auto",
              }}
            >
              Transform your security infrastructure with AI-powered monitoring
              and threat detection
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-eye"
                  style={{
                    fontSize: "40px",
                    color: "#e74c3c",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>
                  Real-Time Threat Detection
                </h4>
                <p className="para">
                  AI-powered computer vision detects suspicious movements,
                  unauthorized access, and unusual behavior instantly with 99.9%
                  accuracy.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-users"
                  style={{
                    fontSize: "40px",
                    color: "#3498db",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>
                  Face Recognition System
                </h4>
                <p className="para">
                  Identify registered personnel, visitors, and blacklisted
                  individuals with high-precision facial recognition technology.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-car"
                  style={{
                    fontSize: "40px",
                    color: "#2ecc71",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>
                  License Plate Recognition
                </h4>
                <p className="para">
                  Automatically capture and log vehicle numbers at all gates for
                  complete vehicle tracking and blacklist alerting.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-bell"
                  style={{
                    fontSize: "40px",
                    color: "#f39c12",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>Instant Alerts</h4>
                <p className="para">
                  Get real-time notifications on mobile or desktop via SMS,
                  email, or app when threats are detected.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-bar-chart"
                  style={{
                    fontSize: "40px",
                    color: "#9b59b6",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>Automated Reports</h4>
                <p className="para">
                  Generate comprehensive daily, weekly, and monthly reports for
                  admin review with export options.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div
                className="feature-box"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                  height: "100%",
                }}
              >
                <span
                  className="fa fa-cloud"
                  style={{
                    fontSize: "40px",
                    color: "#1abc9c",
                    marginBottom: "15px",
                    display: "block",
                  }}
                ></span>
                <h4 style={{ marginBottom: "15px" }}>Cloud Backup</h4>
                <p className="para">
                  Secure cloud storage with 30-day retention and local backup
                  options for complete data security.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center" style={{ marginTop: "40px" }}>
            <p style={{ marginTop: "15px", fontSize: "14px", color: "#666" }}>
              Free 30-day trial | No credit card required | 24/7 support
            </p>
          </div>
        </div>
      </section>

      {/* EyeSense AI Bottom CTA */}
      <section
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "50px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <h3 style={{ fontSize: "32px", marginBottom: "20px" }}>
            Ready to enhance your security with AI?
          </h3>
          <p
            style={{
              fontSize: "18px",
              marginBottom: "30px",
              maxWidth: "700px",
              margin: "0 auto 30px auto",
            }}
          >
            Join thousands of satisfied customers who trust EyeSense AI for
            their surveillance needs
          </p>
          <button
            onClick={downloadEyeSenseAI}
            style={{
              backgroundColor: "#e74c3c",
              color: "white",
              padding: "15px 40px",
              fontSize: "18px",
              fontWeight: "bold",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginRight: "15px",
            }}
          >
            ⬇️ DOWNLOAD EYESENSE AI NOW
          </button>
          <button
            onClick={downloadBrochure}
            style={{
              backgroundColor: "transparent",
              color: "white",
              padding: "15px 30px",
              fontSize: "18px",
              border: "2px solid white",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            📄 Download Brochure
          </button>
          <p style={{ marginTop: "30px", fontSize: "14px", opacity: 0.8 }}>
            Free 30-day trial | Compatible with Windows, macOS, Linux | 24/7
            technical support
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
}
